<script lang="ts">
	import { CreamColor } from "../../../../core/schema/CreamColor.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import cakeConf from "../../../../core/assets/icons/cakeconf.svg";
	import plus from "../../../../core/assets/icons/btn-plus.svg?raw";
	import Button from "../Button.svelte";
	import { creamColorMap } from "../../../../core/schema/creamColorMap.js";
	import ProductOptionHeader from "./ProductOptionHeader.svelte";
	import { calculatePriceForProductOption } from "../../../../core/schema/utils/calculatePriceForProductOption.js";
	import { ProductOption } from "../../../../core/schema/ProductOption.js";
	import { creamColorNameMap } from "../../../../core/schema/names/creamColorNameMap.js";

	export let creamColor: CreamColor | undefined;
	export let updateCreamColor: (color: CreamColor | undefined) => void;
	export let basePrice: number;
	export let minimalPricesForOptions: Record<ProductOption, number>;
	export let changed: boolean | undefined;

	function onChange(_creamColor: typeof creamColor): void {
		if (changed === undefined) {
			changed = false;
			return;
		}
		changed = true;
	}
	$: onChange(creamColor);

	const { TENANT_LOCALE } = getGlobalSettings();

	$: minimalPrice = minimalPricesForOptions[ProductOption.CreamColor];
	$: currentPrice = calculatePriceForProductOption(basePrice, ProductOption.CreamColor, creamColor);
</script>

<ProductOptionHeader name="Pokrýt barevnou šlehačkou" image={cakeConf} price={currentPrice} {minimalPrice}>
	Dort obmažeme nahoře i po bocích vámi vybranou barvou. Ideální volba pro kombinaci s jedlým tiskem.
</ProductOptionHeader>

<div class="flex flex-col gap-[.125rem] sm:gap-1.5">
	{#each Object.values(CreamColor) as value}
		{@const id = `cream-color-${value}`}
		{@const selected = creamColor === value}
		<label
			for={id}
			class="text-secondary outline-secondary relative flex h-10 cursor-pointer items-center justify-center rounded-md border-2 border-white text-[0.625rem] font-bold uppercase leading-4 outline-2 {creamColorMap[
				value
			]}"
			class:outline={selected}
		>
			<input
				type="radio"
				{id}
				name="cream-color"
				class="pointer-events-none absolute inset-0 opacity-0"
				{value}
				bind:group={creamColor}
				required
			/>
			{creamColorNameMap[value][TENANT_LOCALE]}
		</label>
	{/each}
</div>

<Button
	icon={plus}
	iconClass="w-5 h-5"
	class="ml-auto mt-6"
	on:click={() => {
		updateCreamColor(creamColor);
	}}
>
	Uložit úpravu
</Button>
